import { Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Donneescv } from 'src/app/utils/interfaces/new/CVdata.interface';


@Component({
  selector: 'app-cv-choix-benef',
  templateUrl: './cv-choix-benef.component.html',
  styleUrls: ['./cv-choix-benef.component.scss'],
})
export class CvChoixbenefComponent {
 
  constructor(
    
    @Inject(MAT_DIALOG_DATA) public DonneesCV: Donneescv, // Liste des situations passées à la boîte de dialogue
    private dialogRef: MatDialogRef<CvChoixbenefComponent>
  ) {}

  ngOnInit(): void {
    // console.log(this.DonneesCV.);
    // {{beneficiaire.libelleQualite}}, né(e) le dateNaissance - donneesMutuelle.libelle dateDebut dateFin
  }

  afficheInfos(beneficiaire: any): string {
    const dateNaissance = this.afficherDateFormatee(beneficiaire.dateNaissance);
    let mutuelleLibelle = '';
    if(beneficiaire.donneesMutuelle){
       mutuelleLibelle = ' - '+ beneficiaire.donneesMutuelle.libelle
       if(beneficiaire.donneesMutuelle.lstPeriodeDroitsMutuelle[0]){
        mutuelleLibelle += ' du '+this.afficherDateFormatee(beneficiaire.donneesMutuelle.lstPeriodeDroitsMutuelle[0].dateDebut);
        mutuelleLibelle += ' au '+this.afficherDateFormatee(beneficiaire.donneesMutuelle.lstPeriodeDroitsMutuelle[0].dateFin);
       }
    }
    return `${beneficiaire.libelleQualite}, né le ${dateNaissance}${mutuelleLibelle}`;
  }

  afficherDateFormatee(dateNaissance: string): string {
    if (!dateNaissance) return 'Date inconnue'; // Gérer les valeurs nulles ou indéfinies
    // Divise la chaîne en année, mois, jour
    const annee = dateNaissance.slice(0, 4);
    const mois = dateNaissance.slice(4, 6);
    const jour = dateNaissance.slice(6, 8);
  
    // Retourne la date au format JJ/MM/AAAA
    return `${jour}/${mois}/${annee}`;
  }

  // Méthode pour sélectionner une situation
  selectBenef(beneficiaire: any): void {
    beneficiaire.immatriculation = this.DonneesCV.NIR + this.DonneesCV.cleNIR;
  
    if (this.DonneesCV.apCV) {
      beneficiaire.apCV = this.DonneesCV.apCV;
      beneficiaire.contexteApCV = this.DonneesCV.contexteApCV;
      beneficiaire.contexteApCVDetruit = this.DonneesCV.contexteApCVDetruit;
    }
  
    this.dialogRef.close(beneficiaire); // Ferme la boîte de dialogue avec les données sélectionnées
  }
  

  // Méthode pour fermer la boîte de dialogue sans sélectionner
  close(): void {
    this.dialogRef.close();
  }
}
